<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    submitTitle="Submit"
    icon="fa-money-check-edit-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="!isDenyMode">
        <NotificationBarTitle>Warning: This will cancel the price request &amp; remove ALL price update data, including price lists already emailed!</NotificationBarTitle>
      </NotificationBar>
      <NotificationBar type="warning" v-if="hasLinkedPriceLists">
        <NotificationBarTitle>Warning: There are customer price lists in other price request(s) that are linked to this price request as a sales price source!</NotificationBarTitle>
        Cancelling / Denying this price request will result in the linked price lists reverting to active sales prices
      </NotificationBar>
      <FormRow label="Denied Reason" v-if="isDenyMode">
        <FormInputTextArea placeholder="Denied Reason" v-model="responseInfo.deniedReason" field="deniedReason" />
      </FormRow>
      <FormRow label="Cancel Reason" v-if="!isDenyMode">
        <FormInputTextArea placeholder="Cancel Reason" v-model="responseInfo.cancelledReason" field="cancelledReason" />
      </FormRow>      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { ApprovalTypes } from '@/store/types'

export default {
  name: "DenyRequestDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    isDenyMode: {
      type: Boolean,
      default: true
    },
    hasLinkedPriceLists: {
      type: Boolean,
      default: false
    },
    priceRequestId: Number
  },
  data() {
    return {
      responseInfo: {},
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      if(this.isDenyMode)
        return 'Deny Price Update Request'
      else
        return 'Cancel Price Update'
    }
  },
  methods: {
    show(stockData) {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        deniedReason: this.responseInfo.deniedReason,
        cancelledReason: this.responseInfo.cancelledReason
      }

      if(this.$props.isDenyMode) {
        this.$apiService.pricingService.denyPriceRequest(this.priceRequestId, updateData)
        .then(response => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      } else {
        this.$apiService.pricingService.cancelPriceRequest(this.priceRequestId, updateData)
        .then(response => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      }
    },
  }
}
</script>